import { render, staticRenderFns } from "./DashboardDepartament.vue?vue&type=template&id=c2199e3c&scoped=true&"
import script from "./DashboardDepartament.vue?vue&type=script&lang=js&"
export * from "./DashboardDepartament.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDepartament.vue?vue&type=style&index=0&id=c2199e3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2199e3c",
  null
  
)

export default component.exports